import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ReLoginDialog from 'pages/ReloginDialog';
import SessionTimeoutDialog from 'pages/ReactRoot/components/SessionTimeoutDialog';
import { getSessionTimeout } from 'selectors/session';
import SessionTimeout from '../SessionTimeout';
import SessionExpiredDialog from '../SessionExpiredDialog';

export default function SessionManagementProvider({ children }) {
  const xmApiSessionTimeout = !!useSelector(getSessionTimeout);
  useEffect(() => {
    window.opener?.postMessage({
      type: 'LOGGED_IN',
    });
  }, []);

  return (
    <>
      <ReLoginDialog />
      <SessionTimeout />
      <SessionTimeoutDialog isOpen={xmApiSessionTimeout} />
      <SessionExpiredDialog />

      {children}
    </>
  );
}
SessionManagementProvider.displayName = 'SessionManagementProvider';
SessionManagementProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
